import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _objectSpread from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import 'whatwg-fetch';
var UNABLE_TO_PROCESS_REQUEST = 'Unable to process request';
var UNAUTHORIZED = 'UNAUTHORIZED';
var Api = {
  /**
   * Fetch using the GET method
   * @param  {string} endpoint              The endpoint with no beginning slash, example "login" or "login/test"
   * @param  {object} headers               The headers to pass along with call
   * @param  {object} data                  The body data to be passed
   */
  getCookieValue: function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  },
  get: function get(apiRoot, endpoint, data, readRequestVerificationTokenHeader, headers) {
    return new Promise(function (resolve, reject) {
      var timestamp = Date.now();
      var cachebust = endpoint.indexOf('?') > -1 ? '&_=' + timestamp : '?_=' + timestamp;

      if (headers === undefined) {
        headers = {};
      }

      headers['X-Requested-With'] = 'XMLHttpRequest';
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      fetch("".concat(apiRoot).concat(endpoint).concat(cachebust), {
        method: 'GET',
        credentials: 'same-origin',
        headers: headers,
        body: data,
        Pragma: 'no-cache',
        Expires: '0'
      }).then(function (response) {
        checkOk(response, readRequestVerificationTokenHeader, resolve, reject);
      });
    });
  },

  /**
   * Fetch using the POST method
   * @param  {string} endpoint              The endpoint with no beginning slash, example "login" or "login/test"
   * @param  {object} data                  The body data to be passed
   * @param  {string} csrf                  The csrf token that needs to be sent in custom header
   * @param  {object} headers               The headers to pass along with call
   */
  post: function post(apiRoot) {
    var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var data = arguments.length > 2 ? arguments[2] : undefined;
    var csrf = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var defaultHeaders;

    if (csrf && csrf.length > 0) {
      defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Request-Verification-Token': csrf,
        'X-Requested-With': 'XMLHttpRequest'
      };
    } else {
      defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      };
    }

    headers = _objectSpread({}, headers, defaultHeaders);
    return new Promise(function (resolve, reject) {
      fetch("".concat(apiRoot).concat(endpoint), {
        method: 'POST',
        credentials: 'same-origin',
        headers: headers,
        body: JSON.stringify(data)
      }).then(function (response) {
        checkOk(response, false, resolve, reject);
      });
    });
  },
  callDelete: function callDelete(apiRoot, endpoint, data, readRequestVerificationTokenHeader, headers) {
    return new Promise(function (resolve, reject) {
      var timestamp = Date.now();
      var cachebust = endpoint.indexOf('?') > -1 ? '&_=' + timestamp : '?_=' + timestamp;

      if (headers === undefined) {
        headers = {};
      }

      headers['X-Requested-With'] = 'XMLHttpRequest';
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      fetch("".concat(apiRoot).concat(endpoint).concat(cachebust), {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: headers,
        body: data,
        Pragma: 'no-cache',
        Expires: '0'
      }).then(function (response) {
        checkOk(response, readRequestVerificationTokenHeader, resolve, reject);
      });
    });
  }
};
export var ResponseError =
/*#__PURE__*/
function (_Error) {
  _inherits(ResponseError, _Error);

  function ResponseError(message, statusCode) {
    var _this;

    _classCallCheck(this, ResponseError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponseError).call(this, message));
    _this.statusCode = statusCode;
    return _this;
  }

  return ResponseError;
}(_wrapNativeSuper(Error));
export function checkErrorStatus(response, resolve, reject) {
  // anything above 403 we don't care about json just reject with generic error for 404, 500 etc
  if (response.status > 403) {
    return reject(new ResponseError(UNABLE_TO_PROCESS_REQUEST, response.status));
  }

  response.json().then(function (json) {
    if (json && json.error && json.error.message) {
      return reject(new ResponseError(json.error.message, response.status));
    } else {
      return reject(new ResponseError(UNABLE_TO_PROCESS_REQUEST, response.status));
    }
  }).catch(function (ex) {
    return reject(ex);
  });
}
export function checkOk(response, readRequestVerificationTokenHeader, resolve, reject) {
  if (response.ok) {
    if (readRequestVerificationTokenHeader) {
      var requestVerificationHeaderName = 'x-request-verification-token';
      var csrfToken = response.headers.get(requestVerificationHeaderName);
      response.json().then(function (json) {
        if (json) {
          // if 200 has an error property. not ideal but we have to handle old Definitive calls
          if (json.error) {
            handleOkError(json, reject);
          }

          if (typeof csrfToken === 'string') {
            json.csrfToken = csrfToken;
          }

          return resolve(json);
        } else {
          return resolve(true);
        }
      });
    } else {
      response.json().then(function (json) {
        if (json) {
          if (json.error) {
            handleOkError(json, reject);
          }

          return resolve(json);
        } else {
          return resolve(true);
        }
      });
    }
  } else {
    return checkErrorStatus(response, resolve, reject);
  }
}
export function handleOkError(jsonResponse, reject) {
  // if 200 has an error property. not ideal but we have to handle old Definitive calls
  var errorMessage = jsonResponse.hasOwnProperty('message') ? jsonResponse.message : jsonResponse.error;

  if (errorMessage && errorMessage.toLowerCase() !== 'internal error occurred') {
    return reject(new Error(errorMessage));
  } else {
    return reject(new Error(UNABLE_TO_PROCESS_REQUEST));
  }
}
export * from './apiRoutes';
export default Api;